import { render, staticRenderFns } from "./platformIndex.vue?vue&type=template&id=4d454e4f&scoped=true"
import script from "./platformIndex.vue?vue&type=script&lang=js"
export * from "./platformIndex.vue?vue&type=script&lang=js"
import style0 from "./platformIndex.vue?vue&type=style&index=0&id=4d454e4f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d454e4f",
  null
  
)

export default component.exports